<script setup>
import { Head } from "@inertiajs/vue3";

import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";
import VTitleWithBackLink from "@/Shared/VTitleWithBackLink.vue";
import VAlert from "@/Shared/VAlert.vue";
import VDevider from "@/Shared/VDevider.vue";

import VForm from "./_partials/VForm.vue";
import VHeaderButtonInfo from "@/Shared/HeaderButton/VButtonInfo.vue";
import i18n from "@/Plugins/i18n.js";

const props = defineProps({
    title: String,
    additional: Object,
});

const {
    filters,
    canView,
    urlShow,
    urlIndex,
    urlSubmit,
    answers,
    surveyFields,
    survey,
} = props.additional;

const breadcrumbs = [
    {
        url: urlIndex,
        label: "Response List",
    },
    {
        url: "#",
        label: "Edit",
    },
];

i18n.global.locale = "en";
</script>

<template>
    <Head>
        <title>{{ title }}</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <div class="card">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <VTitleWithBackLink
                        :href="urlIndex"
                        :filters="filters ?? {}"
                    >
                        Edit Survey Entries - {{ survey.name }}
                    </VTitleWithBackLink>
                    <div class="btn-wrapper">
                        <VHeaderButtonInfo v-if="canView" :href="urlShow" />
                    </div>
                </div>
                <VDevider class="mb-4" />
                <VAlert />

                <VForm
                    :additional="{
                        formType: 'put',
                        urlSubmit,
                        survey,
                        answers,
                        surveyFields,
                    }"
                />
            </div>
        </div>
    </div>
</template>
